import { render, staticRenderFns } from "./AutoOrderCancel.vue?vue&type=template&id=4a9faf96&scoped=true&"
import script from "./AutoOrderCancel.vue?vue&type=script&lang=js&"
export * from "./AutoOrderCancel.vue?vue&type=script&lang=js&"
import style0 from "./AutoOrderCancel.vue?vue&type=style&index=0&id=4a9faf96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9faf96",
  null
  
)

export default component.exports